import React, { useCallback, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toastr } from 'react-redux-toastr';

import './style.css';

import iconVariavelOrange from '../../../../../assets/images/variavel_orange.svg';
import useVariableSensitivity from './UseVariableSensitivity';
import ConfirmCryptoVariableSave from './ConfirmCryptoVariableSave';

export const valueRegex = /data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,.*/;

const ModalAddBotVariable = ({ isActive, onClose, onSubmit }) => {
  const [iptError, setIptError] = useState(false);
  const [
    variableSensitivity,
    changeVariableSensitivity,
  ] = useVariableSensitivity('DEFAULT');
  const [confirmSaveData, setConfirmSaveData] = useState({
    isOpen: false,
    data: {},
  });

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();

      const name = e.target.name.value;
      const { value } = e.target.value;

      if (valueRegex.test(value)) {
        toastr.error('Erro', 'Valores em Base64 não são permitidos no criador');
        setIptError(true);
      } else {
        if (variableSensitivity === 'ENCRYPTED_DATA') {
          setConfirmSaveData({
            isOpen: true,
            data: { name, value, variableSensitivity },
          });
        } else {
          onSubmit({ name, value, variableSensitivity });
          toastr.success('Sucesso', 'A variável foi armazenada');
        }

        setIptError(false);
      }
    },
    [onSubmit, variableSensitivity]
  );

  return (
    <>
      <Modal show={isActive} onHide={onClose} className="modal-variavel">
        <Modal.Header closeButton>
          <Modal.Title>
            <img src={iconVariavelOrange} alt="Variável" /> Nova variável
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <div>
              <label className="input-container">
                <span className="input-label">Nome</span>
                <input
                  className="input-control"
                  placeholder="{variável}"
                  required
                  name="name"
                />
              </label>
              <label className="input-container">
                <span className="input-label">Valor</span>
                <input
                  className={
                    iptError ? 'input-control border-err' : 'input-control'
                  }
                  placeholder="valor da variável"
                  name="value"
                />
              </label>
              <div
                className="sensitivity-options"
                onChange={(event) =>
                  changeVariableSensitivity(event?.target?.value)
                }
              >
                <label htmlFor="default-option">
                  <input
                    id="default-option"
                    type="radio"
                    value="DEFAULT"
                    name="default-option"
                    checked={variableSensitivity === 'DEFAULT'}
                  />{' '}
                  Padrão
                </label>

                <label htmlFor="not-storage-option">
                  <input
                    id="not-storage-option"
                    type="radio"
                    value="NOT_STORAGE"
                    name="not-storage-option"
                    checked={variableSensitivity === 'NOT_STORAGE'}
                  />{' '}
                  Não armazenar
                </label>
                <label htmlFor="encrypt-option">
                  <input
                    id="encrypt-option"
                    type="radio"
                    value="ENCRYPTED_DATA"
                    name="encrypt-option"
                    checked={variableSensitivity === 'ENCRYPTED_DATA'}
                  />{' '}
                  Criptografar
                </label>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit">salvar</button>
          </Modal.Footer>
        </form>
      </Modal>
      {confirmSaveData?.isOpen && (
        <ConfirmCryptoVariableSave
          isOpen={confirmSaveData?.isOpen || false}
          setConfirmSaveData={setConfirmSaveData}
          data={confirmSaveData?.data || {}}
          isActive={isActive}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      )}
    </>
  );
};

export default ModalAddBotVariable;
